/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import validator from "utils/validator";
import Config from "data/config";
import { objectHasPropertyString } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";
import { isString } from "utils/empty-exists";

const SimplicitySimpleImageLoader = (props) => {
    
    const guid = props?.guid;
    const alt = props?.alt;
    const className = props?.className;
    const enableImageDebug = Config.Debug.useDebug;
    const { token } = useAuth();
    const [image, setImage] = useState();
    const [hasContent, setHasContent] = useState();
    
    useEffect(() => {
        const fetchImageData = async (_guid) => {
            // component has an image property containing the guid of the image
            // First check if the image is improperly saved as an object
            const isImage = validator.isImage(_guid);
            if (isImage) {
                throw Error("SimplicitySimpleImageLoader");
            }
            // - we want a guid at this point not an image
            const isGuid = validator.isGuid(_guid);
            if (isGuid) {
                const fetchData = async () => {
                    const img = await SimpliCityAdminSDK.image.findOne(token, _guid);
                    setImage(img);
                    setHasContent(objectHasPropertyString(img,"guid"));
                };
                fetchData();
            } else {
                Logger.info(`Image property was not valid. [IMAGE: ${JSON.stringify(_guid)}]`);
            }
        };
        if (!image) {
            fetchImageData(guid);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);
    
    return (
        <>
            {hasContent &&
                <img
                    className={className}
                    src={image?.url}
                    alt={alt}
                />
            }
            {enableImageDebug &&
                <details className="in-page-debug-details">
                    <summary className="in-page-debug-summary">
                        Image JSON
                    </summary>
                    <pre className="in-page-debug">
                        Image Guid: {isString(guid)}
                        {JSON.stringify(image, null, 2)}
                    </pre>
                </details>

            }
        </>
    );
};

export { SimplicitySimpleImageLoader };
